export default __webpack_public_path__ + "assets/images/3.558e3c.png";